import "./styles/colors.scss";
import "./shared/components/AppCheckbox/AppCheckbox.module.scss";
import "./features/FestivalAnalysis/components/RedirectButton/RedirectButton.module.scss";
import "./shared/components/HealthText/HealthText.module.scss";
import "./shared/components/AnalysisCard/AnalysisCard.module.scss";
import "./shared/components/OrderToggle/OrderToggle.module.scss";
import { CssBaseline } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';

import App from './App';
import { AppThemeProvider } from './contexts/AppTheme';
import { LocaleProvider } from './contexts/Locale';

window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
  <AppThemeProvider>
    {/* <React.StrictMode> */}
      <LocaleProvider>
        <App />
      </LocaleProvider>
    {/* </React.StrictMode> */}
    <CssBaseline />
    <Toaster position='top-center' containerStyle={{ top: 80 }} />
  </AppThemeProvider>
);
